import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      - Kolorigu min! – petas la Ŝtofpeco. 
      – Mi jam la bastonon por la flagtenilo trovis. 
      Restas nur koloron akiri!
    </p>
    
    <p class="mb-3">
      - Kiun koloron vi deziras? 
      Ĉu nigran, ruĝan, verdan?
    </p>
    
    <p class="mb-3">
      - Nu, mi malbone distingas kolorojn. 
      Faru ajnan: mi nur volas esti flago!
    </p>
    `
  )
}

const itemName = {
  esp: 'La ŝtofpeco'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;